import { render, staticRenderFns } from "./ShareHandLian.vue?vue&type=template&id=01660fe7&scoped=true&"
import script from "./ShareHandLian.vue?vue&type=script&lang=js&"
export * from "./ShareHandLian.vue?vue&type=script&lang=js&"
import style0 from "./ShareHandLian.vue?vue&type=style&index=0&id=01660fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01660fe7",
  null
  
)

export default component.exports